// 9fbef606107a605d69c0edbcd8029e5d
import EARNEXTRAPOINTS_CONSTANTS from '../EarnExtraPointsTile.constants';

export const getEarnExtraPointsList = (payload = {}) => {
  return {
    type: EARNEXTRAPOINTS_CONSTANTS.GET_EARNEXTRAPOINTS_LIST,
    payload,
  };
};

export const getEarnedPointsNotification = () => {
  return {
    type: EARNEXTRAPOINTS_CONSTANTS.GET_EARNEDPOINTS_NOTIFICATION,
  };
};

export const showLoader = () => {
  return {
    type: EARNEXTRAPOINTS_CONSTANTS.SHOW_LOADER,
  };
};

export const hideLoader = () => {
  return {
    type: EARNEXTRAPOINTS_CONSTANTS.HIDE_LOADER,
  };
};

export const setEarnedPointsNotification = (earnedPointsNotification) => {
  return {
    type: EARNEXTRAPOINTS_CONSTANTS.SET_EARNEDPOINTS_NOTIFICATION,
    payload: earnedPointsNotification,
  };
};

export const setEarnExtraPointsList = (extraPointsData) => {
  return {
    type: EARNEXTRAPOINTS_CONSTANTS.SET_EARNEXTRAPOINTS_LIST,
    payload: extraPointsData,
  };
};

export const clearEarnExtraPointsList = () => {
  return {
    type: EARNEXTRAPOINTS_CONSTANTS.CLEAR_EARNEXTRAPOINTS_LIST,
  };
};
